import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=0a77590b&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=0a77590b&prod&lang=scss&scoped=true"
import style1 from "./OrderHistory.vue?vue&type=style&index=1&id=0a77590b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a77590b",
  null
  
)

export default component.exports